"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-6 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap justify-end">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/xproductions",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com/xproductions",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com/xproductions",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/xproductions",
    label: "LinkedIn"
  }];
  return <footer className="bg-dark-background text-foreground-dark py-8 animate-fade-in-up">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6">
          <div className="text-sm text-foreground-dark/80">© 2026 Marlon Lupo. All rights reserved.</div>
          
          <MenuProvider menu_id="3" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        
      </div>
    </footer>;
}